import { BodySmall, ModalHeader, ModalFooter, Modal } from '@parspec/pixel';


interface MaxLocationLimitReachedModalProps {
    isOpen: boolean;
    onClose: () => void,
    maxLocationPermitted: number
}
export const MaxLocationLimitReachedModal = (props: MaxLocationLimitReachedModalProps) => {
    const { isOpen, onClose, maxLocationPermitted } = props
    return (
        <>
            <Modal
                open={isOpen}
                footer={
                    <ModalFooter
                        onAccept={() => {
                            window.open('https://www.parspec.io/parspec-pricing', 'blank');
                            onClose();
                        }}
                        onReject={onClose}
                        continueButtonLabel={'Learn More'}
                    />
                }
                header={<ModalHeader onClose={onClose} title={'Location Limit Reached'}></ModalHeader>}
                onClose={onClose}
            >
                <BodySmall limit={false}>Your active subscription only permits up to {maxLocationPermitted} location(s). Upgrade your plan to unlock more locations.</BodySmall>
            </Modal></>
    )
}